import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { FormActions } from "../../components/common/FormActions";
import { URL_ORGANISATIONS } from "../../utils/urls";
import { API_ORGANISATIONS } from "../../utils/apis";
import { FORM_DATA } from "../../utils/constants";

export const useOrganisations = () => {
  const tableColumns = () => [
    ...["name", "code", "actions"].map((item) => createColumn(item)),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions
            actions={[createEditAction(URL_ORGANISATIONS, item?.id)]}
          />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_ORGANISATIONS);

  return { tableData, tableColumns, formRoute };
};

export const useOrganisationForm = () => {
  const sections: any = [
    {
      title: `Organisation Details`,
      fields: [
        {
          field_name: "name",
          type: "text",
          label: `Organisation Name`,
          props: { required: true },
        },
        {
          field_name: "code",
          type: "text",
          label: `Code`,
          props: { required: true },
        },

        {
          field_name: "logo",
          type: "file",
          label: "Logo",
        },
      ],
    },
  ];

  const redirect = getRegister(URL_ORGANISATIONS);

  return { sections, redirect };
};

export function submitOrganisations(payload: any, id: string) {
  let preparedPayload = { ...payload, logo: payload?.logo?.file[0] };
  //  UPDATE
  if (id) {
    return {
      id,
      api: API_ORGANISATIONS,
      params: preparedPayload,
      type: FORM_DATA,
    };
  }

  // CREATE
  return {
    api: API_ORGANISATIONS,
    params: preparedPayload,
    type: FORM_DATA,
  };
}
